import { useCallback } from 'react'
import { formatInTz } from '@/lib/format'
import { useAccountTimezone } from './use-account-timezone'

export type UseFormatDateResult = {
  format: (dateInput: Date | string, format: string) => string
  isReady: boolean
  tz: string
}

export const useFormatDate = (): UseFormatDateResult => {
  const { timezone, isReady } = useAccountTimezone()

  const format = useCallback(
    (dateInput: Date | string, formatStr: string) => formatInTz(dateInput, formatStr, timezone),
    [timezone],
  )

  return { format, isReady, tz: timezone }
}
